import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import OfficialPage from '../OfficialPage';

import './CollectStars.less';

import { TopNav } from '@common/top-nav/TopNav';

export default class CollectStars extends OfficialPage {
  state = {
    selectedCollectType: '电商',
    isHideTypeNav: true,
    recordTabType: 0,
    collectStarsData: {
      collectedNum: 0,
      collectNum: 8,
      starStyleArr: [
        'dark',
        'dark',
        'dark',
        'dark',
        'dark',
        'dark',
        'dark',
        'dark'
      ],
      dark_img:
        'http://img.zhichiwangluo.com/zcimgdir/album/file_5afac25ca94fb.png'
    },
    starRecordList: {
      list: [],
      isNull: false,
      loadingData: {
        isLoading: false
      }
    },
    awardRecordList: {
      list: [],
      isNull: false,
      loadingData: {
        isLoading: false
      }
    }
  }

  constructor(props) {
    super(props);
    document.title = '集集乐';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      franchiseeId: options.franchisee || ''
    })
    this.getCollectStarsData()
    this.getStarsRecordData()
  }

  componentDidMount() { }

  onReachBottom = () => { }
  initialLoadingData = () => {
    this.setData({
      starRecordList: {
        list: [],
        isNull: false,
        loadingData: {
          isLoading: false
        }
      },
      awardRecordList: {
        list: [],
        isNull: false,
        loadingData: {
          isLoading: false
        }
      }
    })
  }
  getCollectStarsData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appMarketing/GetUserCollectNum',
      data: {
        sub_app_id: that.data.franchiseeId
      },
      success: function (res) {
        let returnData = res.data
        let tempArr = []
        let tempNum = 0
        if (returnData.togetherNum != undefined) {
          // 合计计算
          tempNum = returnData.togetherNum
          for (let i = 0; i < returnData.collectNum; i++) {
            if (i < returnData.togetherNum) {
              tempArr.push('light')
            } else {
              tempArr.push('dark')
            }
          }
        } else {
          // 单独计算
          tempNum = returnData.ecommerceNum
          for (let i = 0; i < returnData.collectNum; i++) {
            if (i < returnData.ecommerceNum) {
              tempArr.push('light')
            } else {
              tempArr.push('dark')
            }
          }
        }
        if (returnData.status == 0) {
          app.showModal({
            content: '没有进行中的活动'
          })
        }
        if (returnData.status == 0 && returnData.isReset == 1) {
          tempNum = 0
          tempArr = [
            'dark',
            'dark',
            'dark',
            'dark',
            'dark',
            'dark',
            'dark',
            'dark'
          ]
        }
        returnData.collectedNum = tempNum
        returnData.starStyleArr = tempArr
        that.setData({
          collectStarsData: returnData
        })
      }
    })
  }
  getStarsRecordData = () => {
    let that = this
    let { starRecordList } = this.data
    let { list, loadingData, isNull } = starRecordList
    if (loadingData.isLoading) {
      return
    }
    that.setData({
      'starRecordList.loadingData.isLoading': true
    })
    app.sendRequest({
      url: '/index.php?r=appMarketing/GetUserCollectRecord',
      data: {
        sub_app_id: that.data.franchiseeId
      },
      hideLoading: true,
      success: function (res) {
        let returnList = res.data
        if (returnList && returnList.length !== 0) {
          loadingData = {
            isLoading: false
          }
          that.setData({
            'starRecordList.list': list.concat(returnList),
            'starRecordList.loadingData': loadingData
          })
        } else {
          that.setData({
            'starRecordList.isNull': true
          })
        }
      },
      complete: function () {
        that.setData({
          'starRecordList.loadingData.isLoading': false
        })
      }
    })
  }
  getAwardRecordData = () => {
    let that = this
    let { awardRecordList } = this.data
    let { list, loadingData, isNull } = awardRecordList
    if (loadingData.isLoading) {
      return
    }
    that.setData({
      'awardRecordList.loadingData.isLoading': true
    })
    app.sendRequest({
      url: '/index.php?r=appMarketing/GetUserRewardsRecord',
      data: {
        sub_app_id: that.data.franchiseeId
      },
      hideLoading: true,
      success: function (res) {
        let returnList = res.data
        if (returnList && returnList.length !== 0) {
          loadingData = {
            isLoading: false
          }
          that.setData({
            'awardRecordList.list': list.concat(returnList),
            'awardRecordList.loadingData': loadingData
          })
        } else {
          that.setData({
            'awardRecordList.isNull': true
          })
        }
      },
      complete: function () {
        that.setData({
          'awardRecordList.loadingData.isLoading': false
        })
      }
    })
  }
  toggleMoreType = () => {
    let { isHideTypeNav } = this.data
    this.setData({
      isHideTypeNav: isHideTypeNav ? false : true
    })
  }
  selectCollectType = e => {
    let collectTypeArr = [
      '电商',
      '到店',
      '当面付',
      '分享赠送',
      '拉新赠送',
      '收藏赠送'
    ]
    let { type } = e.target.dataset
    let { collectStarsData } = this.data
    let tempArr = [],
      tempNum = 0
    if (type == 0) {
      tempNum = collectStarsData.ecommerceNum || 0
    }
    if (type == 1) {
      tempNum = collectStarsData.toStoreNum || 0
    } else if (type == 2) {
      tempNum = collectStarsData.facePayNum || 0
    } else if (type == 3) {
      tempNum = collectStarsData.shareBaseNum || 0
    } else if (type == 4) {
      tempNum = collectStarsData.shareExtraNum || 0
    } else if (type == 5) {
      tempNum = collectStarsData.collectActivityNum || 0
    }
    for (let i = 0; i < collectStarsData.collectNum; i++) {
      if (i < tempNum) {
        tempArr.push('light')
      } else {
        tempArr.push('dark')
      }
    }
    this.setData({
      selectedCollectType: collectTypeArr[type] || '',
      'collectStarsData.collectedNum': tempNum,
      'collectStarsData.starStyleArr': tempArr
    })
    this.toggleMoreType()
  }
  recordTabSwitch = e => {
    let { recordType } = e.currentTarget.dataset
    if (this.data.recordTabType == recordType) {
      return
    }
    this.setData({
      recordTabType: recordType
    })
    this.initialLoadingData()
    if (recordType == 1) {
      this.getAwardRecordData()
    } else {
      this.getStarsRecordData()
    }
  }

  render() {
    const {
      selectedCollectType,
      isHideTypeNav,
      collectStarsData,
      undefined,
      recordTabType,
      starRecordList,
      awardRecordList
    } = this.state
    return (
      <div className="official-page collect-starts">
        <TopNav title="集集乐" />
        <div className="collectStar-container">
          {collectStarsData.togetherNum == undefined && (
            <div className="collect-type-wrapper">
              <div className="type-selected" onClick={this.toggleMoreType}>
                <span>{selectedCollectType}</span>
                <span
                  className={
                    'ico-moon icon-' + (isHideTypeNav ? 'downarrow' : 'uparrow')
                  }
                ></span>
              </div>
              <div
                className="type-list-wrapper"
                style={convertLineStyleData('height: ' + (isHideTypeNav ? '0' : '480rpx') + ';')}
              >
                <div className="type-list" onClick={this.selectCollectType}>
                  <span data-type="0">电商</span>
                  <span data-type="1">到店</span>
                  <span data-type="2">当面付</span>
                  <span data-type="3">分享赠送</span>
                  <span data-type="4">拉新赠送</span>
                  <span data-type="5">收藏赠送</span>
                </div>
              </div>
            </div>
          )}
          <div
            className="collect-info-wrapper"
            style={convertLineStyleData(
              'margin-top:' +
              (collectStarsData.countMethod == 0 ? '10rpx' : '0') +
              ';'
            )}
          >
            <div className="info-num">
              <span>{'集集乐个数：' + collectStarsData.collectedNum + '个'}</span>
            </div>
            <div
              className={'info-star info-star-' + collectStarsData.collectNum}
            >
              {collectStarsData.starStyleArr.map((item, index) => {
                return (
                  <div className="star-item" key={index}>
                    {item == 'light' && (
                      <img
                        className="star-item"
                        src={collectStarsData.light_img}
                        mode="aspectFill"
                      />
                    )}
                    {item == 'dark' && (
                      <img
                        className="star-item"
                        src={collectStarsData.dark_img}
                        mode="aspectFill"
                      />
                    )}
                  </div>
                )
              })}
            </div>
            {collectStarsData.status == 1 ? (
              <div className="info-desc">
                <span className="info-desc-condition">
                  {'消费' +
                    (collectStarsData.playType == 0 ? '每满' : '超过') +
                    collectStarsData.value +
                    '元，累计1颗星，集满可获' +
                    collectStarsData.coupon +
                    '一张'}
                </span>
                {collectStarsData.isReset == 1 ? (
                  <span className="info-desc-time">活动结束星数清空</span>
                ) : (
                    <span className="info-desc-time">活动结束星数保留</span>
                  )}
              </div>
            ) : (
                <div className="info-desc">
                  <span>当前暂无活动</span>
                </div>
              )}
          </div>
          <div className="collect-record-wrapper">
            <div className="record-tab">
              <div
                className={recordTabType == 0 ? 'active' : ''}
                data-record-type="0"
                onClick={this.recordTabSwitch}
              >
                <span>集星记录</span>
                <span className="line"></span>
              </div>
              <div
                className={recordTabType == 1 ? 'active' : ''}
                data-record-type="1"
                onClick={this.recordTabSwitch}
              >
                <span>奖励记录</span>
                <span className="line"></span>
              </div>
            </div>
            <div className="record-content">
              {recordTabType == 0 && (
                <div className="record-star">
                  <div className="record-star-title">
                    <span className="time">集星时间</span>
                    <span className="origin">集星来源</span>
                    <span className="num">集星数量</span>
                  </div>
                  {starRecordList.list && starRecordList.list.length > 0 && (
                    <div className="record-star-list">
                      {starRecordList.list.map((item, index) => {
                        return (
                          <div className="record-star-item" key={index}>
                            <span className="time">{item.collect_time}</span>
                            <span className="origin">{item.collect_type}</span>
                            <span className="num">{item.collect_num}</span>
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {starRecordList.loadingData.isLoading && (
                    <div className="loading-wrap">
                      <div className="loading-view">
                        <div className="loading-dot1"></div>
                        <div className="loading-dot2"></div>
                      </div>
                    </div>
                  )}
                  {starRecordList.isNull && (
                    <div className="record-list-null">
                      <img src="http://cdn.jisuapp.cn/static/webapp/images/request-none.png" />
                      <span>~ 暂无集星记录 ~</span>
                    </div>
                  )}
                </div>
              )}
              {recordTabType == 1 && (
                <div className="record-award">
                  {!awardRecordList.isNull && (
                    <div className="record-award-list">
                      {awardRecordList.list.map((item, index) => {
                        return (
                          <div className="record-award-item" key={index}>
                            <span className="item-title">
                              {item.coupon_title}
                            </span>
                            <div className="item-use-time">
                              <span>使用时间：</span>
                              <span className="item-itme-txt">
                                {item.start_use_date + '至' + item.end_use_date}
                              </span>
                            </div>
                            <span className="item-award-time">
                              {'中奖时间：' + item.recv_time}
                            </span>
                            {item.status == 1 && (
                              <span className="ico-moon icon-winning-record-nouse"></span>
                            )}
                            {item.status == 2 && (
                              <span className="ico-moon icon-winning-record-used"></span>
                            )}
                            {item.status == 3 && (
                              <span className="ico-moon icon-winning-record-invalid"></span>
                            )}
                          </div>
                        )
                      })}
                    </div>
                  )}
                  {/*  加载loading  */}
                  {awardRecordList.loadingData.isLoading && (
                    <div className="loading-wrap">
                      <div className="loading-view">
                        <div className="loading-dot1"></div>
                        <div className="loading-dot2"></div>
                      </div>
                    </div>
                  )}
                  {awardRecordList.isNull && (
                    <div className="record-list-null">
                      <img src="http://cdn.jisuapp.cn/static/webapp/images/request-none.png" />
                      <span>~ 暂无奖励记录 ~</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/collect-stars/CollectStars.jsx